import React, {useState } from 'react'
import axios from 'axios'
import { useForm } from 'react-hook-form'
import './KiContact.scss'
import FormSuccessBox from '../../FormSuccessBox/FormSuccessBox'
import aiStars from '../../../assets/images/ai-stars.png'
import atle from '../../../assets/images/atle.png'

export default function KiContact() {

	const { register, handleSubmit, formState: { errors }, setValue } = useForm({
		mode: 'onSubmit',
		reValidate: 'onChange'
	})
	const [showPopup, setShowPopup] = useState(false)
	const [popupText, setPopupText] = useState('Takk for din tilbakemelding!')

	const onSubmit = (data) => {
		try {
			axios({
				method: 'post',
				url: '/.netlify/functions/dynamic-contact-form',
				data: {...data, subject: 'Interesse for KI søk', toEmail: 'ki@lovdata.no'},
			})
				.then(response => {
					if(response.data.status === 'success') {
						setPopupText('Takk for din tilbakemelding!')
						setShowPopup(true)
						setValue('contactFirstName', '')
						setValue('contactLastName', '')
						setValue('email', '')
					}
					if(response.data.status === 'failed') {
						setPopupText('Beklager, det oppstod en feil. Vennligst prøv igjen senere.')
						setShowPopup(true)
					}
				})

		} catch (err) {
			console.log('error: ', err)
		}
	}

	return(
		<div className="KiContact">
			<FormSuccessBox visible={showPopup} close={() => setShowPopup(false)} text={popupText} />
			<div className="Block-container size-default">
				<img src={aiStars} alt="AI-stjerner" className="aiStars" />
				<h2 className="title">Ta kontakt om du ønsker tidlig tilgang til Lovdata Pro 2 med KI:</h2>
				<div className="content-container">
					<div className="image">
						<img src={atle} alt="Atle" className="atle" />
					</div>
					<div className="content">
						<p>Vi har i dag over 300 testere på den nye løsningen og vi ønsker enda flere! Ta kontakt med Atle på <a href="mailto:ki@lovdata.no">ki@lovdata.no</a> eller send inn navn og epost – så får du tilgang til Lovdata Pro 2 med KI.</p>
						<br/>
						<p>Du må ha konto i Lovdata Pro fra før. Send inn her:</p>
					</div>
				</div>
				<div className="form">
					<form onSubmit={handleSubmit(onSubmit)} className="register-form">
						<div className="doubleFields">
							<div className={errors.contactFirstName ? 'field error' : 'field'}>
								{errors.contactFirstName && <p className="errorMessage">{errors.contactFirstName.message}</p>}
								<label htmlFor="contactFirstName">Fornavn</label>
								<input
									type="text"
									{...register('contactFirstName', {
										required: "Du må fylle inn fornavn",
										minLength: {
											value: 2,
											message: "Navnet du har skrevet inn er for kort"
										},
										pattern: {
											value: /^([^0-9]*)$/,
											message: "Du kan ikke bruke tall i navnet"
										}
									})}
									id="contactFirstName"
									autoComplete="given-name" />
							</div>

							<div className={errors.contactLastName ? 'field error' : 'field'}>
								{errors.contactLastName && <p className="errorMessage">{errors.contactLastName.message}</p>}
								<label htmlFor="contactLastName">Etternavn</label>
								<input
									type="text"
									{...register('contactLastName', {
										required: "Du må fylle inn etternavn",
										minLength: {
											value: 2,
											message: "Navnet du har skrevet inn er for kort"
										},
										pattern: {
											value: /^([^0-9]*)$/,
											message: "Du kan ikke bruke tall i etternavnet"
										}
									})}
									id="contactLastName"
									autoComplete="family-name" />
							</div>
						</div>

						<div className={errors.email ? 'field error' : 'field'}>
							{errors.email && <p className="errorMessage">{errors.email.message}</p>}
							<label htmlFor="email">Epost</label>
							<input
								type="email"
								{...register('email', {
									required: "Du må fylle inn eposten din",
									pattern: {
										value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
										message: "Ugyldig epostadresse"
									}
								})}
								id="email"
								autoComplete="email" />
						</div>

						<div className="submit">
							<button className="Button primary" type="submit"><span>Send</span></button>
						</div>
						</form>
				</div>
			</div>
		</div>
	)
}